export default __webpack_public_path__ + "static/media/icw-Style Guide.c699766f.jpg";